import { Text } from '@antimatterhq/ui/components/typography';
import { count } from '@antimatterhq/ui/utils/format';
import { Skeleton } from '@antimatterhq/ui/components/skeleton';
import { DatasourceSummary } from '@/types/api';

interface DataSourceAlertCountProps {
  summaryWithAlertsAndMetrics: DatasourceSummary;
  period: 'last24hrs' | 'last7days';
  className?: string;
  'data-testid'?: string;
  isLoading: boolean;
}

export const DataSourceAlertCount = ({
  summaryWithAlertsAndMetrics,
  period,
  className,
  'data-testid': testId,
  isLoading,
}: DataSourceAlertCountProps) => {
  const eventCount =
    period === 'last24hrs'
      ? summaryWithAlertsAndMetrics?.alerts?.alertsLast24hours
      : summaryWithAlertsAndMetrics?.alerts?.alertsLast7days;

  if (isLoading) {
    return <Skeleton className="h-4 w-10" />;
  }

  if (eventCount === undefined) {
    return <Text className="font-medium">-</Text>;
  }

  return (
    <div className={className} data-testid={testId}>
      <Text className="font-medium">{count(eventCount)}</Text>
    </div>
  );
};
